import React, { Suspense } from 'react';
import { ErrorBoundary } from '@sentry/react';
import DelayedFallback from './components/DelayedFallback';
import Router from '../Router';
import './style/auth.scss';
import ErrorRenderPage from './ErrorRenderPage';

function AuthLayout() {
  return (
    <div className="loading-holder">
      <ErrorBoundary fallback={ErrorRenderPage} showDialog>
        <Suspense fallback={<DelayedFallback />}>
          <Router />
        </Suspense>
      </ErrorBoundary>
    </div>
  );
}

export default AuthLayout;
